<template>
  <div>
    <h2>{{ title }}</h2>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <input-search />
        <circle-button @click.native="createMembershipBenefit" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.id">
              <td  width="5" align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td width="10">{{ item.branch ? item.branch.branch_name_th : "" }}</td>
              <td width="20">
                {{ item.detail_th }}
              </td>
              <td width="30">
                {{ item.rate }}
              </td>
              <td width="30">
                {{ item.discount_th }}
              </td>
              <td width="30">{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td  width="5">{{ item.orders }}</td>
              <td  width="5">
                <a @click="showMembershipBenefit(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import InputTextField from "../../../components/Input/InputTextField";
import CircleButton from "../../../components/Button/CircleButton";
import IconPencil from "../../../components/Icon/icon-pencil";
import InputSearch from "../../../components/Input/InputSearch";
import Paginate from "../../../components/Layout/Paginate";
export default {
  name: "MembershipBenefitTable",
  components: {Paginate, InputSearch, IconPencil, CircleButton, InputTextField },
  data() {
    return {
      title: "Membership benefit",
      headers: [
        { id: 1, text: "No." },
        { id: 2, text: "Branch" },
        { id: 3, text: "Membership" },
        { id: 4, text: "Rate" },
        { id: 5, text: "Discount" },
        { id: 6, text: "Update date" },
        { id: 7, text: "Order" },
        { id: 8, text: "Edit" }
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      }
    };
  },
  created() {
    this.getMembershipBenefitTable(1);
  },
  methods: {
    goToMembershipBenefitEdit() {
      this.$router.push("/membership-benefit/edit");
    },
    getMembershipBenefitTable(page) {
      this.$store.dispatch("MembershipBenefit/getMembershipBenefit", page).then(res => {
        if (res.response_code === 200) {
          this.dataTable = res.result.data;
        } else {
          alert(res.response_msg);
        }
      });
    },
    changePage(val){
      this.dataPaginate.current_page = val;
      this.$store.dispatch("MembershipBenefit/getMembershipBenefit", this.dataPaginate.current_page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    },
    createMembershipBenefit() {
      this.$store.dispatch("MembershipBenefit/clearFormData").then(() => {
        this.goToMembershipBenefitEdit();
      });
    },
    showMembershipBenefit(id) {
      this.$store.dispatch("MembershipBenefit/showMembershipBenefit", id).then(res => {
        if (res.response_code == 200) {
          this.$store
            .dispatch("MembershipBenefit/setFormMembershipBenefit", res.result)
            .then(() => {
              this.goToMembershipBenefitEdit();
            });
        } else {
          alert(res.response_msg);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/table.css";
@import "../../../assets/css/variables";
.branch-data {
  background-color: transparent;
  margin: 20px;
}
.theme--light.v-system-bar {
  background-color: transparent !important;
  color: rgba(0, 0, 0, 0.6);
}
</style>
